export const GTM_EVENTS = {
  APPOINTMENT_CONFIRMED: 'appointment_confirmed',
  ADD_TO_CART: 'add_to_cart',
  PURCHASE: 'purchase',
  SELECT_TIME: 'select_time',
  MAIN_BOOKING_PAYMENT_FAILURE: 'main_booking_payment_failure',
  PURCHASE_SELF_PAYMENT: 'purchase_self_payment',
  PURCHASE_INSURANCE: 'purchase_insurance',
  VIEW_SERVICE_PAGE: 'view_service_page',
  VIEW_ITEM: 'view_item',

  BEGIN_BOOKING: 'begin_booking',
  VIEW_DOCTOR_PROFILE: 'view_doctor_profile',
  CALL_DOCTOR: 'call_doctor',
  CLICK_DOCTOR_SEND_MESSAGE: 'click_doctor_send_message',
  MAIN_BOOKING_CHOSEN_CATEGORY: 'main_booking_chosen_category',
  MAIN_BOOKING_SELECT_DOCTOR: 'main_booking_select_doctor',
  REACH_MAIN_BOOKING_BY: 'reach_main_booking_by',
  REACH_MAIN_BOOKING_PAYMENT_STEP: 'reach_main_booking_payment_step',
  MAIN_BOOKING_REACH_PAYMENT_FROM_SERVICE:
    'main_booking_reach_payment_from_service',
  CHOSEN_SLOT_EVENT: 'chosen_slot',
  MAIN_SUCCESSFUL_BOOKING: 'main_successful_booking',
  SUCCESSFUL_SEND_INQUIRY_FORM: 'successful_send_Inquiry_form',
  REFERRAL_FORM_SUBMISSION: 'referral_form_submission',
  CONTACT_US_FORM_SUBMISSION: 'contact_us_form_submission',
  CAREERS_FORM_SUBMISSION: 'careers_form_submission',
  BOOKING_COMPLETED: 'booking_completed',

  REACH_PHARMACY_BOOKING_BY: 'reach_pharmacy_booking_by',
  PHARMACY_CHOSEN_CATEGORY_AND_SERVICE: 'pharmacy_chosen_category_and_service',
  PHARMACY_CHOSE_TIME_SLOT: 'pharmacy_chose_time_slot',
  PHARMACY_COMPLETE_USER_STEP: 'pharmacy_complete_user_step',
  PHARMACY_PAYMENT_FAILURE: 'pharmacy_payment_failure',
  PHARMACY_SUCCESSFUL_BOOKING: 'pharmacy_successful_booking',
  PHARMACY_PURCHASE: 'pharmacy_purchase',
  FILL_FORM: 'fill_form',
} as const;

export type GtmEventName = (typeof GTM_EVENTS)[keyof typeof GTM_EVENTS];

export const GTM_DATA_LAYER_KEYS = {
  PAGE_PATH: 'page_path',
  CHOSEN_CATEGORY: 'chosen_category',
  CHOSEN_DOCTOR: 'chosen_doctor',
  CHOSEN_SLOT: 'chosen_slot',
} as const;
